<template>
	<v-container id="container" class="pt-0" fluid>
		<v-card>
			<v-card-title>
				Welcome
				<v-spacer></v-spacer>
				<v-text-field
					v-model="search"
					append-icon="mdi-magnify"
					label="Search"
					single-line
					hide-details
				></v-text-field>
			</v-card-title>
			<v-card-text>
				<v-data-table
					v-if="$store.getters.superuser"
					:headers="headers"
					:items="servers"
					:search="search"
				>
					<template v-slot:item.domain="{ value }">
						<a :href="`https://${value}`" target="_blank">{{ value }}</a>
					</template>
					<template v-slot:item.status="{ item }">
						<v-chip v-if="item.twitchChannelName === null || item.twitchChannelName === ''">
							Not applicable
						</v-chip>
						<div v-else class="d-flex">
							<div class="d-flex align-center">
								<a :href="`https://twitch.tv/${item.twitchChannelName}`" target="_blank">
									<font-awesome-icon :icon="['fab','twitch']" class="mr-5"/>
								</a>
							</div>
							<v-chip v-if="item.isTwitchChannelLive" color="green" text-color="white">
								Streaming
							</v-chip>
							<v-chip v-else color="red" text-color="white">
								Not streaming
							</v-chip>
						</div>
					</template>
					<template v-slot:item.actions="{ item }">
						<v-btn color="success" :disabled="restartInProgress" @click="restartServer(item)">
							<font-awesome-icon icon="sync-alt" class="mr-1"/>
							Restart
						</v-btn>
					</template>
				</v-data-table>
			</v-card-text>
		</v-card>
	</v-container>
</template>

<script>
import {fetchServers, restartStream} from '@/api/server.api'

export default {
	name: "Dashboard",
	created() {
		if (this.$store.getters.superuser) {
			this.fetchData();
		}
	},
	data() {
		return {
			restartInProgress: false,
			servers: [],
			search: '',
			headers: [
				{
					text: 'Domain',
					align: 'start',
					sortable: false,
					value: 'domain',
				},
				{
					text: 'Status',
					align: 'start',
					sortable: false,
					value: 'status'
				},
				{text: 'Actions', value: 'actions'},
			],
		}
	},
	methods: {
		async fetchData() {
			const {data} = await fetchServers();
			this.servers = data.servers;
		},
		restartServer(server) {
			this.restartInProgress = true;
			restartStream(server.id).then((response) => {
				if (response.data.success) {
					this.$swal.fire({
						icon: "success",
						title: `Stream for ${server.domain} restarted successfully.`,
						text: 'Please wait a few seconds for the stream to start.',
						timer: 2000,
						showConfirmButton: false
					});
				} else {
					this.$swal.fire({
						icon: "error",
						title: "Error restarting server stream.",
						text: response.data.error,
						timer: 2000,
						showConfirmButton: false
					});
				}
			}).catch(() => {
				this.$swal.fire({
					icon: "error",
					title: "Couldn't restart server stream.",
					timer: 2000,
					showConfirmButton: false
				});
			}).finally(() => {
				this.restartInProgress = false;
			})
		}
	}
};
</script>

<style lang="scss" scoped></style>
